export default __webpack_public_path__ + "static/media/commerce-background.13bb0ebc.svg";